import * as React from 'react';
/**
 *
 * Original name: email secondary
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A359
 *
 */
export const EmailSecondaryPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M8 14v30a6.007 6.007 0 0 0 6 6h20v-4H14a2 2 0 0 1-2-2V20.828l20 20 20-20V42h4V14H8Zm6.828 4h34.344L32 35.172 14.828 18Z", fill: "currentColor" }),
    React.createElement("path", { d: "m47.789 41.895-3.578-1.789A11.347 11.347 0 0 1 38 46v4a11.352 11.352 0 0 1 6.211 5.895l3.578-1.789A16.775 16.775 0 0 0 44.926 50H56v-4H44.926a16.772 16.772 0 0 0 2.863-4.105Z", fill: "currentColor" })));
